import {combine, createEffect, createEvent, createStore} from 'effector';

import {fetchProductContentGrid} from 'api';
import {DocumentCodesCache, DocumentsCodesTreeRow} from 'types';

import {formatNavigationCodesTreeRow} from 'utils/markingCodes';

export const navigateToChildren = createEvent<DocumentsCodesTreeRow>();
export const navigateBack = createEvent<number>();
export const resetNavigation = createEvent();
export const setCurrentLevelData = createEvent<DocumentsCodesTreeRow[] | null>();

export const fetchChildrenFx = createEffect({
    name: 'fetchChildrenFx',
    handler: async (params: {aggregationNumber: string; gtin: string}) => {
        const cache = $childrenCache.getState();
        const key = params.aggregationNumber;
        if (cache[key]) return cache[key];

        return (
            await fetchProductContentGrid({
                ...params,
                sortings: [],
                filters: [],
                paging: {pageNumber: 0, pageSize: 50},
            })
        ).map(formatNavigationCodesTreeRow);
    },
});

export const $breadcrumbs = createStore<DocumentsCodesTreeRow[]>([]);

export const $currentCode = createStore<string | null>(null);

export const $currentLevelData = createStore<DocumentsCodesTreeRow[]>([]);

export const $childrenCache = createStore<DocumentCodesCache>({});

export const $state = combine({
    cache: $childrenCache,
    currentData: $currentLevelData,
    currentCode: $currentCode,
    breadcrumbs: $breadcrumbs,
    active: $breadcrumbs.map((b) => !!b.length),
    pending: fetchChildrenFx.pending,
});
